import React, { Component } from 'react';
import FakeData from '.././fake-data';
import { Link } from 'react-router-dom';

import './Sports.css';
import { LoadingState, EmptyState } from '../components/Common';

export default class Sports extends Component {
    constructor(props) {
        super(props);
        this.state = {
            active: "",
            sport: "All",
            isShowingMore: true,
            isLoading: false,
            img: "",
            search:"",
            results: {
                Clubs: [],
                Teams: [],
                Instituitions: [],
                Tournaments: []
            },
            limit: 10,
            sportObj: { id: null, name: "" }
        }
    }

    getSports = (a) => {
        const sports = FakeData.listify(FakeData.getData("all_sports"));
        const filter = a ? a : this.state.active;
        if (this.state.active === "" && !a) {
            return sports;
        }

        const list = sports.filter((item, i) => {
            return FakeData.nullify(item.name).charAt(0).toLowerCase() === filter.toLowerCase();
        })

        return list;
    }

    render() {
        const { active, sport, isShowingMore, img, isLoading, results, limit, sportObj, search } = this.state;
        var consonants = 'abcdefghijklmnopqrstuvwxyz'.split("");
        let rem = this.getSports().length % 4;
        rem = rem === 1 ? 3 : rem === 3 ? 1 : rem;
        return (
            <div className="search-page" style={{ background: "#fff", width: FakeData.width, zIndex:0 }}>
                <div className="all-sport-alpha-filter">
                    <div className={active === "" ? "active" : ""} onClick={() => this.setState({ active: "", sport: "All", isShowingMore: true })}>All</div>
                    {
                        consonants.map((item, i) => {
                            if (this.getSports(item).length === 0) {
                                return null;
                            }
                            return (
                                <div key={i} className={active === item ? "active" : ""} onClick={() => this.setState({ active: item, isShowingMore: true })}>{item.toUpperCase()}</div>
                            )
                        })
                    }
                </div>
                {!isShowingMore &&
                    <div className="all-sport-sp-filter">
                        <div className="active">
                            <img src={img} />
                            <span>{sport}</span>
                            <i className="material-icons" onClick={() => {
                                this.setState({ isShowingMore: true })
                            }} >close</i>
                        </div>
                        <div className="all-sport-sp-filter-sh">
                            <input ref={"search-fld"} placeholder="Search..." />
                            <i className="material-icons" onClick={()=>{
                                const val = this.refs["search-fld"].value;
                                console.log(val);
                                this.setState({search:val})
                            }}>search</i>
                        </div>
                    </div>
                }
                {isShowingMore &&
                    <div className="all-sport-sp-filter-more">
                        {
                            this.getSports().map((item, i) => {
                                return (
                                    <div key={i} onClick={() => {
                                        this.setState({ sport: item.name, sportObj: item, img: item.image, isLoading: false, isShowingMore: false })
                                        //this.getSportsData(item)
                                    }} style={{ height: "50px", lineHeight: "50px" }}>
                                        <img src={item.image.replace("_wht", "")} />
                                        {item.name}
                                    </div>
                                )
                            })
                        }
                        {
                            FakeData.getDummy(rem).map((item, i) => {
                                return (
                                    <div key={i} style={{ height: "50px", color: "#fff", lineHeight: "50px" }}>
                                        {i}
                                    </div>
                                )
                            })
                        }
                    </div>
                }

                {!isShowingMore &&
                    <div style={{ width: "100%" }}>

                        <CategoryList label="Teams" search={search} sport={sportObj} key={"Teams-".sport} labelKey={"Teams-".sport} />

                        <CategoryList label="Clubs" search={search} sport={sportObj} key={"Clubs-".sport} labelKey={"Clubs-".sport} />

                        <CategoryList label="Institutions" search={search} sport={sportObj} key={"Institutions-".sport} labelKey={"Institutions-".sport} />

                        <CategoryList label="Tournaments" search={search} sport={sportObj} key={"Tournaments-".sport} labelKey={"Tournaments-".sport} />

                    </div>
                }
            </div>
        );
    }
}

class CategoryList extends Component {
    constructor(props) {
        super(props);
        this.state = {
            data: [],
            limit: 51,
            offset: 50,
            isLoading: true,
            isLoadingMore: false
        }
    }

    componentDidMount() {
        FakeData.mountState(this.props.labelKey, true)
        this._isMounted = true;
        this.getSportsData(this.props.sport)
    }

    componentWillUnmount() {
        FakeData.mountState(this.props.labelKey, false)
        this._isMounted = false
    }

    getSportsData = (sport, cb) => {
        const { limit } = this.state;
        const _that = this;
        sport.queryString = this.props.search;
        const data = {
            user: {
                id: FakeData.getData("yoo").id,
                type: "F"
            },
            sport,
            offset: limit,
            dataType: this.props.label
        }

        FakeData.post("/getSportsData.php?auth0", data, {
            success(res) {
                if (!FakeData.isMounted(_that.props.labelKey)) {
                    return
                }

                _that.setState({ data: res, isLoading: false });
                if (cb) {
                    cb();
                } else {
                    FakeData.$("#root").scrollTop(0)
                }
            },
            error(err) {
                FakeData.alert("No results were found!")
                _that.setState({ isLoading: false });
            }
        }, false, "", (r) => { })
    }

    render() {
        const { data, isLoading, offset, isLoadingMore, limit } = this.state;
        if (!isLoading && data.length === 0) {
            //return null;
        }

        return (
            <CategoryItem label={this.props.label}>
                {!isLoading &&
                    data.filter((item)=> {return FakeData.nullify(item.name).indexOf(this.props.search.toLowerCase())>-1}).map((item, i) => {
                        const lim = data.length > offset ? offset - 2 : offset - 1;
                        if (i > lim) {
                            return null;
                        }
                        return (
                            <div className="sp-cat-team" key={i}>
                                <img src={item.image} />
                                <span className="sp-cat-team-tooltip">{item.name}</span>
                            </div>
                        )
                    })
                }
                {!isLoading && data.filter((item)=> {return FakeData.nullify(item.name).indexOf(this.props.search.toLowerCase())>-1}).length > offset &&
                    <div className="sp-cat-team" onClick={() => {
                        const _lim = limit + 50;
                        this.setState({ isLoadingMore: true, limit: _lim });
                        this.getSportsData(this.props.sport, () => {
                            const _off = offset + 50;
                            this.setState({ isLoadingMore: false, offset: _off });
                        })
                    }}>
                        <i className="material-icons">{isLoadingMore ? "compare_arrows" : "autorenew"}</i>
                        <span>MORE</span>
                    </div>
                }
                {!isLoading && data.filter((item)=> {return FakeData.nullify(item.name).indexOf(this.props.search.toLowerCase())>-1}).length === 0 &&
                    <EmptyState style={{ background: "#fff" }} isShown={true} text="No results were found!" icon="landscape" />
                }
                {isLoading &&
                    <LoadingState isShown={isLoading} text={"Loading " + this.props.sport.name + " Data"} />
                }
            </CategoryItem>
        );
    }
}

const CategoryItem = (props) => {
    return (
        <div className="sp-cat-item">
            <div className="sp-cat-item-hd">{props.label}</div>
            <div className="sp-cat-item-ctx">{props.children}</div>
        </div>
    )
}


// WEBPACK FOOTER //
// ./src/pages/Sports.jsx